import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { LabTestPanelDto, UpsertLabTestPanelDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/lab-test-panel`;

export const getAllLabTestPanels = (
    source: CancelTokenSource)
    : Promise<LabTestPanelDto[]> => {

  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
}

export const getLabTestPanel = (
    id: number,
    source: CancelTokenSource)
    : Promise<UpsertLabTestPanelDto> => {

  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
}

export const addLabTestPanel = (
    upsertLabTestPanel: UpsertLabTestPanelDto,
    source: CancelTokenSource)
    : Promise<LabTestPanelDto> => {

  return axios
      .post(apiUri, upsertLabTestPanel, {cancelToken: source.token})
      .then(response => response.data);
}

export const editLabTestPanel = (
    id: number,
    upsertLabTestPanel: UpsertLabTestPanelDto,
    source: CancelTokenSource)
    : Promise<LabTestPanelDto> => {

  return axios
      .put(`${apiUri}/${id}`, upsertLabTestPanel, {cancelToken: source.token})
      .then(response => response.data);
}

export const deleteLabTestPanel = (
    id: number,
    source: CancelTokenSource)
    : Promise<string> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
}
